import { render, staticRenderFns } from "./AutoRenew.vue?vue&type=template&id=085655a0&scoped=true"
import script from "./AutoRenew.vue?vue&type=script&lang=js"
export * from "./AutoRenew.vue?vue&type=script&lang=js"
import style0 from "./AutoRenew.vue?vue&type=style&index=0&id=085655a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085655a0",
  null
  
)

export default component.exports